export default "__VITE_ASSET__LxJ0p36u__"